import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api/client'
import { PageShell } from '../components/BrandChrome'
import { Alert, Button, Card, FieldError, Input, Label, Subtitle, Title } from '../components/ui'
import { errorMessage } from '../lib/format'

export function RegisterPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [doneEmail, setDoneEmail] = useState<string | null>(null)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      const res = await api.register(email.trim(), password)
      setDoneEmail(res.email)
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <PageShell homeTo="/login">
      <Card className="mx-auto max-w-md">
        <Title>Create account</Title>
        <Subtitle>Use your work email. You will verify before signing in.</Subtitle>
        {doneEmail ? (
          <Alert tone="success">
            Account created for <strong>{doneEmail}</strong>. Check your email for a verification
            link, then <Link to="/login">sign in</Link>.
          </Alert>
        ) : (
          <form className="space-y-4" onSubmit={onSubmit}>
            {error ? <Alert>{error}</Alert> : null}
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                required
                minLength={12}
                value={password}
                onChange={(ev) => setPassword(ev.target.value)}
                aria-describedby="password-hint"
              />
              <p id="password-hint" className="mt-1 text-sm text-slate-500">
                At least 12 characters.
              </p>
              {password.length > 0 && password.length < 12 ? (
                <FieldError>Password must be at least 12 characters.</FieldError>
              ) : null}
            </div>
            <Button type="submit" disabled={busy} className="w-full">
              {busy ? 'Creating…' : 'Create account'}
            </Button>
          </form>
        )}
        <p className="mt-4 text-center text-sm text-slate-600">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </Card>
    </PageShell>
  )
}
